import ContactFormFr from 'components/ContactUs/ContactFormFr'
import FooterFr from 'components/FooterFr'
import NavbarFr from 'components/NavbarFr'
import React from 'react'
import { useEffect } from "react";

function ContactUsFr() {

  useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    <NavbarFr />
    <ContactFormFr />
    <FooterFr />
    </>
  )
}

export default ContactUsFr